import { useFormik } from "formik";
import Select from "../../../components/select";
import { useSubnetList } from "../layout/resuableEffect";
import * as Yup from "yup";
import Input from "../../../components/input";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNetworkSubnet, listNetwork, deleteSubnet } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import TextArea from "../../../components/textArea";
import { useState } from "react";
import { FormatDate } from "../../../hooks/constants";
import close from "../../../assets/svg-icons/closeBrand.svg";
import Ports from "./ports";
import Modal from "../../../components/modal";
import { Link } from "react-router-dom";
import usePartnerNavigation from "../../../hooks/usePartnerNavigation";


const NetworkDetails = () => {

  document.title = "Network Details - Cloudvantage";


  const dispatch = useDispatch();
  const { navigate, generatePartnerUrl } = usePartnerNavigation();


  const selectedProject = useSelector((state) => state.user.selectedProject);
  const selectedNetwork = JSON.parse(sessionStorage.getItem("selectedNetwork"));

  const [network, setNetwork] = useState(null);
  const [isFetched, setIsFetched] = useState(false); 

  const [searchText, setSearchText] = useState("");
  const [networkModal, setNetworkModal] = useState(false);
  const [manageSubnetModal, setManageSubnetModal] = useState(false);
  const [editNetworkModal, setEditNetworkModal] = useState(false); 
  const [editSubnetModal, setEditSubnetModal] = useState(false);
  const [deleteSubnetModal, setDeleteSubnetModal] = useState(false);
  const [subnetDetailsModal, setSubnetDetailsModal] = useState(false); 
  const [selectedSubnet, setSelectedSubnet] = useState(null);


  const handleGetNetwork = async () => {
    if (!selectedNetwork?.networkId || !selectedProject?.id) {
      return;
    }

    const networkId = selectedNetwork.networkId;
    const projectId = selectedProject.id;

    const { payload } = await dispatch(listNetwork({ projectId, networkId }));
    
    setNetwork(payload);
    setIsFetched(true);
  };

  // Call handleGetNetwork immediately if not fetched yet
  if (!isFetched && selectedNetwork && selectedProject) {
    handleGetNetwork();
  }


  const [selectedTab, setSelectedTab] = useState("Overview");

  const networkTabs = [
    "Overview",
    "Subnets",
    "Ports"
  ]

  const overviewDetails = [
    {
        title: "Name",
        value: network?.name || "N/A",
    },

    {
        title: "Network ID",
        value: network?.id || "N/A",
    },

    {
        title: "Project ID",
        value: network?.project_id || "N/A",
    },

    {
        title: "Status",
        value: network?.status
    },

    {
        title: "Admin State",
        value: network?.admin_state_up ? "UP" : "DOWN" || "N/A",
    },

    {
        title: "Shared",
        value: network?.shared ? "Yes" : "No" || "N/A",
    },

    {
        title: "External Network",
        value: network ? (network["router:external"] ? "Yes" : "No") : "N/A",
    },

    {
        title: "MTU",
        value: network?.mtu || "N/A",
    },
  ]


  const subnetOverviewDetails = selectedSubnet
  ? [
      {
        title: "Name",
        value: selectedSubnet?.name || "N/A",
      },
      {
        title: "Subnet ID",
        value: selectedSubnet?.id || "N/A",
      },
      {
        title: "Project ID",
        value: selectedSubnet?.project_id || "N/A",
      },
      {
        title: "Status",
        value: selectedSubnet?.status || "N/A",
      },
      {
        title: "Admin State",
        value: selectedSubnet?.admin_state_up ? "UP" : "DOWN" || "N/A",
      },
      {
        title: "Shared",
        value: selectedSubnet?.shared ? "Yes" : "No" || "N/A",
      },
      {
        title: "External Network",
        value: selectedSubnet ? (selectedSubnet["router:external"] ? "Yes" : "No") : "N/A",
      },
      {
        title: "MTU",
        value: selectedSubnet?.mtu || "N/A",
      },
    ]
  : [];

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-subnets", label: "All subnets" },
    { value: "name", label: "Subnet Name" },
  ];

  
  
    const showManageSubnetModal = (key, data) => {
        setManageSubnetModal(key);
        const subnetDetails = { subnetId: data.id, subnetName: data.name };
        sessionStorage.setItem("selectedSubnet", JSON.stringify(subnetDetails));
    };
    
   const closeManageSubnetModal = () => {
      setManageSubnetModal(false);
   };
  
  
    const toggleSubnetModal = () => {
        setSelectedSubnet(!selectedSubnet);
    };
  
    const toggleEditSubnetModal = (subnet) => {
      setSelectedSubnet(subnet);
      setEditSubnetModal(!editSubnetModal);
    };


    const showSubnetDetailsModal = (subnet) => {
        setSelectedSubnet(subnet);
        setSubnetDetailsModal(true);
    };


    const closeSubnetDetailsModal = () => {
        setSubnetDetailsModal(false);
        setSelectedSubnet(null);
    };


    const params = `?network_id=${selectedNetwork?.networkId}`
    const subnetList = useSubnetList(selectedProject?.id, params);

    







    const subnetListMap = Array.isArray(subnetList)
        ? subnetList.map((subnet) => ({
            id: subnet.id,
            name: subnet.name && subnet.name.trim() !== "" ? subnet.name : "Default Subnet",
            networkAddress: subnet?.cidr || "N/A",
            ipVersion: subnet?.ip_version === 4 ? "IPv4" : "IPv6",
            gatewayIp: subnet?.gateway_ip || "N/A",
            createdAt: FormatDate(subnet.created_at),
        }))
        : [];

      const [currentPage, setCurrentPage] = useState(1);
      const entriesPerPage = 5;
    
      const filteredData = subnetListMap?.filter((row) =>
        row?.name?.toLowerCase().includes(searchText.toLowerCase())
      );
    
      const indexOfLastEntry = currentPage * entriesPerPage;
      const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
      const currentEntries = filteredData.slice(
        indexOfFirstEntry,
        indexOfLastEntry,
      );
      const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    
      const handlePreviousPage = () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const handleNextPage = () => {
        if (currentPage < totalPages) {
          setCurrentPage(currentPage + 1);
        }
      };
        
  const ipVersionOptions = [
    { value: "IPv4", label: "IPv4" },
    { value: "IPv6", label: "IPv6" },
  ];

  const createSubnet = useFormik({

    initialValues: {
      subnetName: "",
      networkAddress: "",
      ipVersion: "IPv4",
      gatewayIp: "",
      disableGateway: false,
      allocationPools: [],
      dnsServers: [],
      subnetpoolId: "",
    },

    enableReinitialize: true,
    validationSchema: Yup.object({
      subnetName: Yup.string().required("Subnet name cannot be empty"),
      networkAddress: Yup.string().required("Network address cannot be empty"),
      gatewayIp: Yup.string().when("disableGateway", {
        is: (value) => value === false,
        then: (schema) =>
          schema.matches(
            /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
            "Invalid Gateway IP format (e.g., 192.168.0.254)"
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    onSubmit: async (values, { resetForm }) => {
      const { subnetName, networkAddress, ipVersion, gatewayIp, disableGateway, allocationPools, dnsServers } = values;

      const transformedIP = ipVersion.replace("IPv", "");

      let subnetData = {
        name: subnetName,
        cidr: networkAddress,
        ip_version: parseInt(transformedIP),
        projectId: selectedProject.id,
        networkId: selectedNetwork?.networkId,
        allocation_pools: allocationPools,
        gateway_ip: disableGateway ? null : gatewayIp || undefined,
        // subnetpool_id: "",
      };

      const { payload } = await dispatch(createNetworkSubnet(subnetData));
      if (payload.statuscode === "00") {
        navigate("/networks");
        resetForm();
      }
    },
  });


      const handleServerAction = async (action, subnetId) => {
        const projectId = selectedProject.id;
  
        const { payload } = await dispatch(action({ projectId, subnetId }));
    
        if (payload.statuscode === "00") {
          window.location.reload();
        }
      };
    
  
    const deleteNetworkSubnet = (subnetId) =>
      handleServerAction(deleteSubnet, subnetId);
  

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
      <p className="crimson-font text-2xl font-medium text-primaryBlue mb-10">Network Details for {selectedNetwork?.networkName} </p>
      

      <div className="flex flex-col justify-start items-start w-full border-b dark:border-b-gray-500 border-b-gray-400">
            <div className="flex justify-start items-center w-full md:w-[50%]">
                {networkTabs.map((tab, i) => (
                    <button
                        key={i}
                        className={`w-full p-4 ${selectedTab === tab ? "bg-primaryBlue text-white rounded-md" : "text-primaryBlue"}  text-sm`}
                        onClick={() => setSelectedTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>
      </div>  

      {selectedTab === "Overview" && (
        <div className="bg-white dark:bg-slate-800 rounded-md  w-full md:w-[50%] py-6 grid gap-4 px-10 mt-8 border-t-4 border-t-primaryBlue border border-primaryBlue">
            {overviewDetails.map((item, i) => (
                <div key={i} className="w-full flex lg:flex-row flex-col justify-start lg:justify-between items-start lg:items-center gap-2 lg:gap-6">
                    <h2 className="text-xl font-bold text-black dark:text-white">{item?.title}</h2>
                    <p className="text-base text-gray-600 dark:text-gray-400">{item?.value}</p>
                </div>
            ))}     
        </div>
      )}


      {selectedTab === "Subnets" && (
        <div>
            {subnetListMap?.length > 0 ?
            <div>
                <div className="w-full flex items-center">
                    <div className="w-full  grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                        <div className="md:col-span-3">
                            <Select label="Filter networks" name="networks" options={options} />
                        </div>
                        <div className="md:col-span-4">
                        <input
                            type="search"
                            name=""
                            value={searchText}
                            onChange={handleSearchChange}
                            placeholder="Search for subnet..."
                            className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                        />
                        </div>
                    </div>
                    <div className="w-full flex items-end justify-end">
                        <Link 
                            to={subnetList?.length === 1 ? "#" : generatePartnerUrl("/networks/create-subnet")}>
                            <button
                                className={`${subnetList?.length === 1 ? "cursor-not-allowed opacity-20" : "cursor-pointer"}  px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                                disabled={subnetList?.length === 1}
                                
                            >
                                Create subnet
                            </button>
                        </Link>
                    </div>

                </div>

                <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
                <table className="w-full text-sm text-left overflow-hidden">
                    <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                    <tr>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                            #
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                            Subnet name
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Network Address
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            IP Version
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Gateway IP
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Actions
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                    {currentEntries.map((row, index) => (
                        <tr
                        key={index}
                        className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                        >
                        <td className="text-start py-4 px-6">{index + 1}.</td>
                        <td
                          className="text-start py-4 px-6 text-primaryBlue hover:underline cursor-pointer"
                          onClick={() => showSubnetDetailsModal(subnetList.find((s) => s.id === row.id))}
                        >
                          {row.name}
                        </td>
                        <td className="text-start py-4 px-6">{row.networkAddress}</td>
                        <td className="text-start py-4 px-6">{row.ipVersion}</td>
                        <td className="text-start py-4 px-6">{row.gatewayIp}</td>
                        <td className="text-start py-4 px-6">
                            <button
                                className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                                onClick={() => showManageSubnetModal(index, row)}
                            >
                                Manage Subnet
                            </button>

                            {manageSubnetModal === index && (
                                <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                                    <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                                    <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                                        <div className="flex gap-2 items-center">
                                            <span className="dark:text-white">
                                                Manage "{row.name}"
                                            </span>
                                            </div>
                                            <img
                                                src={close}
                                                onClick={closeManageSubnetModal}
                                                className="h-5 cursor-pointer"
                                                alt=""
                                            />
                                        </div>
                                    <div className="p-4 grid gap-1">
                                        <Link 
                                            to={generatePartnerUrl("/networks/edit-subnet")}
                                            className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                                        >
                                            <span>Edit subnet</span>
                                            <span>
                                                <img src={arrow} alt="" className="" />
                                            </span>
                                        </Link>
        
                                        <div
                                            className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                            onClick={() => {
                                                setDeleteSubnetModal(true);
                                            }}
                                        >
                                            <span className="hover:underline">
                                                Delete subnet
                                            </span>
                                        </div>
                                    </div>
                                    <Modal
                                        title={"Delete Subnet"}
                                        isVisible={deleteSubnetModal}
                                        onClose={() => setDeleteSubnetModal(false)}
                                    >
                                        <div className="text-sm text-center pt-6 text-wrap">
                                            Are you sure you want to delete{" "}
                                            <span className="underline">{row.name}</span> .
                                            This action cannot be undone.
                                        </div>
                                        <div className="grid gap-4 justify-center py-6">
                                            <button
                                                className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                                onClick={() => deleteNetworkSubnet(row.id)}

                                            >
                                                Yes, delete {row.name}
                                            </button>
                                            <button
                                                className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                                onClick={() => setDeleteSubnetModal(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Modal>
            
                                  </div>
                                </div>
                            )}

                        </td>
    
                    </tr>
                    ))}
                    </tbody>
                </table>
                </div>
                <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
                <p className="text-gray-400 text-sm">
                    Showing{" "}
                    <span className="font-medium text-black dark:text-white">
                        {indexOfFirstEntry + 1}
                    </span>{" "}
                        to{" "}
                    <span className="font-medium text-black dark:text-white">
                        {Math.min(indexOfLastEntry, subnetListMap?.length)}
                    </span>{" "}
                        of{" "}
                    <span className="font-medium text-black dark:text-white">
                        {subnetListMap?.length}
                    </span>{" "}
                    results
                </p>
                <div className=" flex gap-3">
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
                </div>
            </div>
    
            :
    
            <>
                <div className="md:px-52 text-center grid text-gray-500 mt-32">
                    <div>It looks like you don't have subnets attached to this network yet. Once you create a subnet, your subnets will appear here.</div>
                    <div className="w-full flex flex-col items-center justify-center mt-4">
                        <Link 
                            to={generatePartnerUrl("/networks/create-subnet")}>
                            <button
                                className={`cursor-pointer px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                            >
                                Create subnet
                            </button>
                        </Link>
                    </div>
                </div>
            
            </> 
            
            }
            
        </div>
      )}

        {selectedTab === "Ports" && (
            <Ports/>
        )}


    {/* Subnet Details Modal */}
      {subnetDetailsModal && selectedSubnet && (
        <div className="fixed w-full bg-black/60 top-0 left-0 z-50 h-screen">
          <div className="w-full flex h-full items-center justify-center p-4">
            <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
              <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                <span className="text-primaryBlue font-medium">Subnet Information:</span>
                <span onClick={closeSubnetDetailsModal} className="cursor-pointer">
                  <img src={close} alt="Close" className="h-5" />
                </span>
              </div>

              <div className="py-10 grid gap-6 px-6">
                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                    Subnet Details:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {subnetOverviewDetails.map((detail, index) => (
                      <div key={index} className="w-full flex flex-col items-start">
                        <h4 className="text-black dark:text-white text-lg">{detail.title}:</h4>
                        <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                          {detail.title === "Status" ? (
                            detail.value === "ACTIVE" ? (
                              <div className="flex gap-1 items-center bg-emerald-500 text-white py-2 px-6 rounded-md">
                                <span>Active</span>
                              </div>
                            ) : (
                              <div className="flex gap-1 items-center bg-red-600 text-white py-2 px-6 rounded-md">
                                <span>{detail.value}</span>
                              </div>
                            )
                          ) : (
                            detail.value
                          )}
                        </h4>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default NetworkDetails;

